import { render, staticRenderFns } from "./GeneralAutoSelect.vue?vue&type=template&id=479fca70&scoped=true&lang=pug&"
import script from "./GeneralAutoSelect.vue?vue&type=script&lang=ts&"
export * from "./GeneralAutoSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479fca70",
  null
  
)

export default component.exports